import { render } from "./SceneSettings.vue?vue&type=template&id=917da000&ts=true"
import script from "./SceneSettings.vue?vue&type=script&lang=ts"
export * from "./SceneSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__